import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form/immutable';

import app from 'reducers/app';
import user from 'reducers/user';
import workflows from 'reducers/workflows';
import brand from 'reducers/brand';
import userBrands from 'reducers/userBrands';
import typeItems from 'reducers/typeItems';
import dashboard from 'reducers/dashboard';
import location from 'reducers/location';
import locations from 'reducers/locations';
import menu from 'reducers/menu';
import menus from 'reducers/menus';
import menuItems from 'reducers/menuItems';
import menuItem from 'reducers/menuItem';
import menuItemCategories from 'reducers/menuItemCategories';
import menuItemSale from 'reducers/menuItemSale';
import menuItemSales from 'reducers/menuItemSales';
import recipeCategories from 'reducers/recipeCategories';
import recipe from 'reducers/recipe';
import recipes from 'reducers/recipes';
import recipeStep from 'reducers/recipeStep';
import recipeSteps from 'reducers/recipeSteps';
import ingredient from 'reducers/ingredient';
import ingredients from 'reducers/ingredients';
import menuItemCost from 'reducers/menuItemCost';
import menuItemCostRecipes from 'reducers/menuItemCostRecipes';
import menuItemStandardCost from 'reducers/menuItemStandardCost';
import products from 'reducers/products';
import design from 'reducers/design';
import designs from 'reducers/designs';
import recentDesigns from 'reducers/recentDesigns';
import designItem from 'reducers/designItem';
import designSection from 'reducers/designSection';
import designItems from 'reducers/designItems';
import designSections from 'reducers/designSections';
import organizations from 'reducers/organizations';
import themes from 'reducers/themes';
import pdf from 'reducers/pdf';
import excel from 'reducers/excel';
import jpeg from 'reducers/jpeg';
import canvas from 'reducers/canvas';
import editor from 'reducers/editor';
import foodTypeDesignTemplates from 'reducers/foodTypeDesignTemplates';
import userMessages from 'reducers/userMessages';
import editableTable from 'reducers/editableTable';
import collapsibles from 'reducers/collapsibles';
import drawers from 'reducers/drawers';
import designItemMappings from 'reducers/designItemMappings';
import buzzCard from 'reducers/buzzCard';
import poster from 'reducers/poster';
import seasonalFlowDesignTemplates from 'reducers/seasonalFlowDesignTemplates';
import useItAgainDesignTemplates from 'reducers/useItAgainDesignTemplates';
import cleanSimpleDesignTemplates from 'reducers/cleanSimpleDesignTemplates';
import upcomingOccaDesignTemplates from 'reducers/upcomingOccaDesignTemplates';
import caterConcesDesignTemplates from 'reducers/caterConcesDesignTemplates';
import typeItemGalleries from 'reducers/typeItemGalleries';
import mainColorDesignTemplates from 'reducers/mainColorDesignTemplates';
import themesGraphicCategory from 'reducers/themesGraphicCategory';
import themesOccasion from 'reducers/themesOccasion';
import enlargeViewDesignTemplates from 'reducers/enlargeViewDesignTemplates';
import searchBgDesignTemplates from 'reducers/searchBgDesignTemplates';
import searchBgResultDesignTemplates from 'reducers/searchBgResultDesignTemplates';
import filterSearchBgResults from 'reducers/filterSearchBgResults';
import searchBackgroundFilter from 'reducers/searchBackgroundFilter';
import globalParameter from 'reducers/globalParameter';
import designParameter from 'reducers/designParameter';
import customIngredients from 'reducers/customIngredients';
import syscoProducts from 'reducers/syscoProducts';
import batchrecipes from 'reducers/batchrecipes';
import batchrecipe from 'reducers/batchrecipe';
import prevMenuAnalysis from 'reducers/prevMenuAnalysis';
import menuAnalysis from 'reducers/menuAnalysis';
import searchProductCatalogFilter from 'reducers/searchProductCatalogFilter';
import globalAlert from 'reducers/globalAlert';
import account from 'reducers/account';
import designLayouts from 'reducers/designLayouts';
import commonAlert from 'reducers/commonAlert';
import customUom from 'reducers/customUom';
import recipeCustomCategories from 'reducers/recipeCustomCategories';
import orderGuide from 'reducers/orderGuide';
import menuItemCustomCategories from 'reducers/menuItemCustomCategories';
import menuCandidateCategories from 'reducers/menuCandidateCategories';
import customIngredient from 'reducers/customIngredient';
import ingredientsSearch from 'reducers/ingredientsSearch';
import salesPeriods from 'reducers/salesPeriods';
import customSize from 'reducers/customSize';
import session from 'reducers/session';
import salesConsultant from 'reducers/salesConsultant';
import opco from 'reducers/opco';
import gbp from 'reducers/gbp';
import globalPrice from 'reducers/globalPrice';
import notifications from 'reducers/notifications';
import designImport from 'reducers/designImport';
import fonts from 'reducers/fonts';
import assetTransfer from 'reducers/assetTransfer';
import assetTransferStats from 'reducers/assetTransferStats';
import currentStatsCount from 'reducers/currentStats';
import selectiveTransfer from 'reducers/selectiveTransfer';
import contentstack from 'reducers/contentstack';
import ingredientReplacement from 'reducers/ingredientReplacement';

export default combineReducers({
  app,
  user,
  workflows,
  brand,
  userBrands,
  dashboard,
  location,
  locations,
  menu,
  menus,
  menuItem,
  menuItems,
  menuItemCategories,
  menuItemSale,
  menuItemSales,
  recipeCategories,
  recipe,
  recipes,
  recipeStep,
  recipeSteps,
  ingredient,
  ingredients,
  menuItemCost,
  menuItemCostRecipes,
  menuItemStandardCost,
  products,
  design,
  designs,
  recentDesigns,
  designItem,
  designSection,
  designItems,
  designSections,
  designItemMappings,
  organizations,
  themes,
  pdf,
  excel,
  jpeg,
  canvas,
  editor,
  foodTypeDesignTemplates,
  typeItems,
  userMessages,
  editableTable,
  collapsibles,
  drawers,
  form,
  buzzCard,
  poster,
  seasonalFlowDesignTemplates,
  useItAgainDesignTemplates,
  cleanSimpleDesignTemplates,
  upcomingOccaDesignTemplates,
  caterConcesDesignTemplates,
  typeItemGalleries,
  mainColorDesignTemplates,
  themesGraphicCategory,
  themesOccasion,
  enlargeViewDesignTemplates,
  searchBgDesignTemplates,
  searchBgResultDesignTemplates,
  filterSearchBgResults,
  searchBackgroundFilter,
  prevMenuAnalysis,
  menuAnalysis,
  globalParameter,
  designParameter,
  customIngredients,
  syscoProducts,
  batchrecipes,
  batchrecipe,
  searchProductCatalogFilter,
  globalAlert,
  account,
  designLayouts,
  commonAlert,
  customUom,
  recipeCustomCategories,
  orderGuide,
  menuItemCustomCategories,
  menuCandidateCategories,
  customIngredient,
  ingredientsSearch,
  salesPeriods,
  customSize,
  session,
  salesConsultant,
  opco,
  gbp,
  globalPrice,
  notifications,
  designImport,
  fonts,
  assetTransfer,
  assetTransferStats,
  currentStatsCount,
  selectiveTransfer,
  contentstack,
  ingredientReplacement
});
